var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 140,
    viewBox: "0 0 117 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_299_9868",
    maskUnits: "userSpaceOnUse",
    x: 0.960938,
    y: 0.71875,
    width: 116,
    height: 139,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.960938,
    y: 0.71875,
    width: 116,
    height: 139
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96094 58.7382C7.96094 30.6056 30.8478 7.71875 58.9609 7.71875C87.0935 7.71875 109.961 30.6056 109.961 58.7382C109.961 79.0605 98.0512 97.2456 79.5358 105.406L62.1278 130.41C61.4089 131.44 60.2238 132.062 58.9804 132.062H58.9609C57.7175 132.062 56.5324 131.44 55.8135 130.41L38.3861 105.406C19.8707 97.2456 7.96094 79.0605 7.96094 58.7382Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96094 58.7382C7.96094 30.6056 30.8478 7.71875 58.9609 7.71875C87.0935 7.71875 109.961 30.6056 109.961 58.7382C109.961 79.0605 98.0512 97.2456 79.5358 105.406L62.1278 130.41C61.4089 131.44 60.2238 132.062 58.9804 132.062H58.9609C57.7175 132.062 56.5324 131.44 55.8135 130.41L38.3861 105.406C19.8707 97.2456 7.96094 79.0605 7.96094 58.7382Z",
    fill: "#E13827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5358 105.406L76.7128 99.0001L74.914 99.7928L73.7909 101.406L79.5358 105.406ZM62.1278 130.41L67.8675 134.417L67.8727 134.41L62.1278 130.41ZM55.8135 130.41L50.0707 134.413L50.0738 134.417L55.8135 130.41ZM38.3861 105.406L44.1289 101.403L43.006 99.792L41.2091 99.0001L38.3861 105.406ZM58.9609 0.71875C26.9801 0.71875 0.960938 26.7414 0.960938 58.7382H14.9609C14.9609 34.4699 34.7155 14.7188 58.9609 14.7188V0.71875ZM116.961 58.7382C116.961 26.7431 90.963 0.71875 58.9609 0.71875V14.7188C83.224 14.7188 102.961 34.4681 102.961 58.7382H116.961ZM82.3588 111.811C103.408 102.534 116.961 81.8401 116.961 58.7382H102.961C102.961 76.2808 92.6945 91.9567 76.7128 99.0001L82.3588 111.811ZM67.8727 134.41L85.2807 109.405L73.7909 101.406L56.3829 126.411L67.8727 134.41ZM58.9804 139.062C62.5375 139.062 65.8545 137.301 67.8675 134.417L56.3881 126.403C56.9634 125.579 57.9101 125.062 58.9804 125.062V139.062ZM58.9609 139.062H58.9804V125.062H58.9609V139.062ZM50.0738 134.417C52.0868 137.301 55.4038 139.062 58.9609 139.062V125.062C60.0312 125.062 60.9779 125.579 61.5532 126.403L50.0738 134.417ZM32.6433 109.408L50.0707 134.413L61.5563 126.408L44.1289 101.403L32.6433 109.408ZM0.960938 58.7382C0.960938 81.8401 14.514 102.534 35.5631 111.811L41.2091 99.0001C25.2273 91.9567 14.9609 76.2808 14.9609 58.7382H0.960938Z",
    fill: "white",
    mask: "url(#path-1-outside-1_299_9868)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMarker);
export default __webpack_public_path__ + "static/media/red-marker.5736e6f5f9e4f0aae50e6613cfab1855.svg";
export { ForwardRef as ReactComponent };